import { WORKFLOW } from '@src/workflows/vs-standard-form/vs-standard-form.constant';
import he from 'he';

export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function getAlignLeftCSS(isAlignLeft: boolean) : string{
  return isAlignLeft ? 'vs-align-left' : 'vs-align-center';
}

export function getDataFromPropString(parsedString: string) {
  try {
    return JSON.parse(parsedString);
  } catch (e) {
    if (parsedString?.split(',')?.length > 0) {
      return parsedString.split(',');
    } else {
      return [];
    }
  }
}

export function isDirRtl() {
  return document.querySelector('html').dir === 'rtl';
}

export function isWhiteBackground(color: string) {
  return (!color
    || color?.length === 0
    || color === 'white'
    || color === '#fff'
    || color === '#ffffff');
}

export const isNullOrUndefined = (...values) => {
  return values.every(value => {
    return value === null || value === undefined;
  });
};

export const isNaN = (value) => {
  if ('isNaN' in Number) {
    return Number.isNaN(value);
  }

  return typeof (value) === 'number' && value !== value;
};

// START GENAI@CHATGPT4
export const getUrlParameter = (name: string): string => {
  if (!name) return '';
  if (!window.location) return '';

  const regex = new RegExp(`[\?\&]${name.replace(/[\[\]]/g, '\\$&')}=([^&#]*)`);
  const results = regex.exec(window.location.href);

  return results ? decodeURIComponent(results[1]) : '';
};
// END GENAI@CHATGPT4

export const isALPWorkflow = (workflow: string) => {
  return (workflow ?? '').toLowerCase() === WORKFLOW.ALP;
};

export const isRedemptionWorkflow = (workflow: string) => {
  return (workflow ?? '').toLowerCase() === WORKFLOW.REDEMPTION;
};

export const isUnenrollVOPWorkflow = (workflow: string) => {
  return (workflow ?? '').toLowerCase() === WORKFLOW.UNENROLL_VOP;
};

/* START GENAI@CHATGPT4 */
export function decodeString(encodedString: string): string {
  let decodedString = '';
  let entityDecodedString = '';
  try {
    // Decode HTML entities
    entityDecodedString = (he && he.decode(encodedString)) || '';
    // Decode URI component
    decodedString = decodeURIComponent(entityDecodedString);
  } catch (e) {
    console.error("Decode string failed: ", e.message);
    return entityDecodedString;
  }
  return decodedString;
}

/* END GENAI@CHATGPT4 */

export const arraysAreEqual = (arr1: any[], arr2: any[]): boolean => {
  return JSON.stringify(arr1) === JSON.stringify(arr2);
};

/* START GENAI@CHATGPT4 */
export const updateListBasedOnCheckboxState = (list, targetValue, isChecked) => {
  if (isChecked) {
    if (!list.includes(targetValue)) {
      return [...list, targetValue];
    }
  } else {
    if (list.includes(targetValue)) {
      return [...list.filter(item => item !== targetValue)];
    }
  }
  return [...list];
};

export const updateOrRemoveFromList = (list, targetValue, replacementObject) => {
  if (!Array.isArray(list) || targetValue == null || typeof replacementObject !== 'object' || !replacementObject.hasOwnProperty('values')) {
    return list;
  }

  let found = false;

  const updatedList = list.map((currentObject) => {
    if (currentObject.key === targetValue) {
      found = true;
      return { ...currentObject, values: replacementObject.values };
    }
    return currentObject;
  });

  if (!found) {
    updatedList.push({ key: targetValue, values: replacementObject.values });
  }

  return updatedList;
};

/* END GENAI@CHATGPT4 */
